import { Pipe, PipeTransform } from '@angular/core';

import { GetBooleanResultPipe } from './get-boolean-result.pipe';

import { Menu } from '../interfaces/user';

@Pipe({ name: 'getMenuParent' })
export class GetMenuParentPipe implements PipeTransform {

  /*  transform(): Pipe que a partir de una estructura menú, devuelve el id de los hijos
    value: Menú
  */
  transform = (value: Menu): string[] => this.getChilds(value, []);

  /* getChilds(): Método devuelve el id de los hijos
    value: Menú o submenú
    childs: Listado de hijos por cada submenú
  */
  getChilds(value: Menu, childs: string[]): string[] {
    // ↓ Verifica si el menú no tiene hijos
    if (new GetBooleanResultPipe().transform(Object.keys(value), ["id", "link"], "includeAll")) {
      // ↓ Asigna el id del hijo al listado
      childs.push(value.id as string);
    } else {
      // ↓ Itera los hijos para obtener los id
      Object.values(value).forEach((el: Menu) => childs = this.getChilds(el, childs));
    }
    // ↓ Devuelve el listado de hijos
    return childs;
  }

}
